document.addEventListener('DOMContentLoaded', () => {

   /*
   * Stagger Animation
   */
   const staggerGroups = document.querySelectorAll('[data-stagger-anim]');

   const staggerObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
         if (!entry.isIntersecting) return;
         [...entry.target.children].forEach((item, index) => {
            setTimeout(() => {
               item.classList.add('is-visible');
            }, index * 120);
         });
         staggerObserver.unobserve(entry.target);
      });
   }, {
      threshold: 0.2
   });


   staggerGroups.forEach(group => staggerObserver.observe(group));


   /*
    * Bounce Animation
    */
   const bounceGroups = document.querySelectorAll('[data-bounce-anim]');

   const showBounceGroup = (group) => {
      [...group.children].forEach((item, index) => {
         setTimeout(() => {
            item.classList.add('is-visible');
         }, index * 150);
      });
   };

   const bounceObserver = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
         if (!entry.isIntersecting) return;

         bounceObserver.unobserve(entry.target);

         requestAnimationFrame(() => {
            showBounceGroup(entry.target);
         });
      });
   }, {
      threshold: 0
   });

   bounceGroups.forEach(group => {
      bounceObserver.observe(group);
   });


   /*
    * Image Parallax
    */
   const images = document.querySelectorAll('.js-image-parallax img');

   if (images.length) {
      const speed = 0.1; // The lower the number, the weaker the parallax.

      function updateParallax() {
         const windowHeight = window.innerHeight;

         images.forEach(function (image) {
            const rect = image.parentElement.getBoundingClientRect();

            // If the element is in the visibility zone
            if (rect.bottom > 0 && rect.top < windowHeight) {
               // Offset from the center of the screen
               const offset =
                  (rect.top + rect.height / 2 - windowHeight / 2) * speed;

               image.style.transform = `translateY(${offset}px)`;
            }
         });
      }

      window.addEventListener('scroll', updateParallax, { passive: true });
      window.addEventListener('resize', updateParallax);

      updateParallax();
   }


   /*
   * Icons Animation
   */
   const icons = document.querySelectorAll('.wcl-icon-animation');

   const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
         if (!entry.isIntersecting) return;

         const index = [...icons].indexOf(entry.target);

         entry.target.style.animationDelay = `${index * 0.12}s`;
         entry.target.classList.add('is-visible');

         observer.unobserve(entry.target);
      });
   }, {
      threshold: 0.45
   });

   icons.forEach((icon) => observer.observe(icon));
});